import { RootState } from 'types/redux';

export const selectToasts = (state: RootState) => state.toast.toasts;
